/** Bek 2026-10-03: "say I want to suspend his account because I find this is strict violence, so I should be able to
 *  suspend." What suspending or restoring the whole account does, said the same way on the tile and the host page. */
export const accountNote={
  suspend:'Suspends the whole account, not just live: their app signs them out, sign-in is refused and they cannot go live. Nothing is deleted. Deciding this broadcast is separate, and you can restore the account here or on the host page.',
  restore:'The account becomes active again and they can sign in. Live access, strikes and any live ban are not changed.',
};
